import { Link, useLocation } from 'react-router-dom'
import { Icon } from '@iconify/react'
import { pageLinks } from '@/pageLinks'

const navItems = [
  { key: 'dashboard', label: '概览', icon: 'lucide:layout-dashboard', path: pageLinks.Dashboard() },
  { key: 'components', label: '组件库', icon: 'lucide:layers', path: pageLinks.ComponentList() },
  { key: 'tokens', label: 'Design Tokens', icon: 'lucide:palette', path: pageLinks.TokenOverview() },
  { key: 'changelog', label: '变更日志', icon: 'lucide:history', path: pageLinks.Changelog() },
]

function NavItem({ item, isActive }: { item: typeof navItems[number]; isActive: boolean }) {
  return (
    <Link
      to={item.path}
      className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-xl transition-all duration-200 ${
        isActive
          ? 'bg-[#1D263A]/5 text-[#1D263A] font-medium'
          : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
      }`}
    >
      <Icon icon={item.icon} className="text-lg" />
      <span>{item.label}</span>
    </Link>
  )
}

export function LayoutSidebar() {
  const location = useLocation()

  function isActive(key: string) {
    const path = location.pathname
    if (key === 'dashboard') return path === '/'
    if (key === 'components') return path.startsWith('/components') || path.startsWith('/preview')
    if (key === 'tokens') return path.startsWith('/tokens')
    if (key === 'changelog') return path === '/changelog'
    return false
  }

  return (
    <div className="w-64 p-6 pr-0 flex flex-col h-full shrink-0">
      <div className="bg-white rounded-[24px] h-full shadow-[0_8px_30px_rgb(0,0,0,0.04)] flex flex-col overflow-hidden">
        <div className="p-6 flex items-center gap-3">
          <div className="w-8 h-8 rounded-xl bg-[#1D263A] flex items-center justify-center shadow-[0_4px_12px_rgba(79,70,229,0.3)]">
            <Icon icon="lucide:box" className="text-white text-xl" />
          </div>
          <span className="font-bold text-lg tracking-tight">ComponentHub</span>
        </div>

        <nav className="flex-1 px-4 py-2 space-y-1 overflow-y-auto">
          <div className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3 px-3 mt-2">主菜单</div>
          {navItems.map((item) => (
            <NavItem key={item.key} item={item} isActive={isActive(item.key)} />
          ))}
        </nav>

        <div className="p-4 border-t border-gray-100 mt-auto">
          <div className="flex items-center gap-3 w-full p-2 rounded-xl">
            <div className="w-8 h-8 rounded-full bg-gradient-to-tr from-[#1D263A] to-[#151D2E] text-white flex items-center justify-center font-medium text-sm shadow-sm">
              设
            </div>
            <div className="flex flex-col text-left">
              <span className="text-sm font-medium text-gray-900">设计团队</span>
              <span className="text-xs text-gray-500">ComponentHub</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
